import React, { useState, useEffect, useRef } from 'react';
import { styled } from 'styled-components';
import HintText from './HintText';

const DropdownContainer = styled.div`
    min-width: 350px;
    margin-bottom: 16px;

    @media (max-width: 600px) {
        max-width: 100%;
    }
`;

const ContractDropdown = ({ label, selectedValue, onChange, hintText, extras = {} }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    
    // Normalize options to ensure they are always objects
    const options = (extras.options || []).map(option =>
        typeof option === 'object' ? option : { value: option, text: option }
    );

    const selectedOption = options.find((o) => o.value === selectedValue);

    const toggleDropdown = () => {
        setIsOpen((prev) => !prev);
    };

    const handleSelect = (option) => {
        onChange(option.value);
        setIsOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <DropdownContainer className="dropdown-container contract-component-container" ref={dropdownRef}>
            <div className="form-label">
                <span className="fw-bold">{label} </span>
                {hintText && <HintText hintText={hintText} />}
            </div>
            <div className="dropdown">
                <button
                    className="btn btn-outline-secondary border-0 dropdown-toggle shadow-sm component-bg min-width-350"
                    onClick={toggleDropdown}
                >
                    {selectedOption?.text || label}
                </button>
                {isOpen && (
                    <div className="dropdown-menu show">
                        {options.map((option, index) => (
                            <button
                                key={index}
                                className="dropdown-item min-width-350"
                                onMouseDown={() => handleSelect(option)}
                            >
                                {option.text}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </DropdownContainer>
    );
};


export default ContractDropdown;
